module.exports = __webpack_public_path__ + "static/contact-zig-zag-img-bce160e90afd7563c3705c16fb81da22.png";